namespace Areas.Projects {
    "use strict";

    //
    //CRUD functions
    //

    var formCrudOps: FormCrudOperations;
    $(() => { init(); });

    function init() {

        formCrudOps = new FormCrudOperations("Projects");
    }    

    export function insertRecord(e: any) {
        formCrudOps.insertRecord();
    }

    export function updateRecord(e: any) {
        formCrudOps.updateRecord();
    }

    export function deleteRecord() {
        formCrudOps.deleteRecord();
    }

    export function undeleteRecord(e: any) {
        const form: any = $("#ProjectsForm").dxForm("instance");
        const formData: any = form.option("formData");  

        formData.IsActive = true;
        form.option("formData", formData);    

        formCrudOps.updateRecord();

    }

    export function fillId(e) {

        var dataGrid = $('#ProjectUsersGrid').dxDataGrid('instance');
        var projectId = dataGrid.option('projectId');

        e.data.inspectionProjectId = projectId;
        e.data.isActive = true;
        e.data.CCEmailRequested = false;
        e.data.CCEmailAssign = false;
        e.data.CCEmailCompleted = false;
        e.data.CCEmailRejected = false;
        e.data.CCEmailDeputyInspections = false;
        e.data.IsDeputyInspector = false;
        e.data.CCEmailOtherReport = false;
        e.data.CCEmailNonComplianceReport = false;
    }
    export function insertRequestAccess(e) {
        var newData: any = $('#ProjectRequestAccessForm').dxForm('instance').option('formData');
        var result: any = $("#ProjectRequestAccessForm").dxForm("instance").validate();

        if (result.isValid) {
            $.ajax({
                url: "/Projects/RequestAccess/Post",
                method: "POST",
                contentType: "application/json",
                data: JSON.stringify(newData),
                success: function (result) {
                    if (result.url) {
                        DevExpress.ui.notify("Save Completed", "success", 1000);
                        window.location.href = result.url;
                    } else {
                        DevExpress.ui.notify(result.errormsg, "error", 5000);
                    }
                },
                error: function (msg) {
                    DevExpress.ui.notify("Error in request: " + msg.responseText, "error", 3000);
                }
            });
        }
    }

    export function newInspectionGroup(e) {

        var dataGrid = $('#InspectionGroupsGrid').dxDataGrid('instance');
        var inspectionProjectId = dataGrid.option('InspectionProjectId');

        e.data.inspectionProjectId = inspectionProjectId;
    }

    export function massInsertInspectionGroup() {

        $("#MassInsertInspectionGroupPopup").dxPopup("show");
    }

    export function cancelMassInsertInspectionGroup() {

        $("#MassInsertInspectionGroupPopup").dxPopup("instance").hide();
    }

    export function saveMassInsertInspectionGroup() {

        var newData = { inspectionProjectId: null, list: null };
        var dataGrid = $('#InspectionGroupsGrid').dxDataGrid('instance');
        newData.inspectionProjectId = dataGrid.option('InspectionProjectId');
        newData.list = $('#inspectionGroupList').val();

        var url = "/Projects/InspectionGroups/MassInsert";
        var data = JSON.stringify(newData);
        sendRequest(url, data, "POST", () => {
            $('#InspectionGroupsGrid').dxDataGrid("instance").refresh();
            $("#MassInsertInspectionGroupPopup").dxPopup("instance").hide();
        });

    }
}
